import CourseLandingContents from '../CourseLanding/Contents';
import mountComponents from '../utils/mounter';
import ReactDOM from 'react-dom';
import * as React from 'react';

(function() { 
  const videoEl = document.getElementById('hero_video');
  if(!videoEl) return;


  videoEl.addEventListener('canplaythrough', () => {
    videoEl.play();
  });

  const modalEl = document.getElementById('trailer_modal');
  const playBtnEl = document.getElementById('play_button');

  function closeTrailerModal() {
    modalEl.classList.remove('is-visible');
    document.body.classList.remove('modal-active');
    modalPlayer.pauseVideo();
  }
  modalEl.querySelector('.modal-close').addEventListener('click', () => {
    closeTrailerModal();
  });

  function openTrailerModal() {
    modalEl.classList.add('is-visible');
    document.body.classList.add('modal-active');

    window.modalPlayer.playVideo();
  }


  document.getElementById('modal_learn_more').addEventListener('click', () => {
    // @TODO: Scroll down on the page.
    closeTrailerModal();
  });


  document.querySelectorAll('.js-play-trailer').forEach( el => {
    el.addEventListener('click', openTrailerModal) 
  })

  ReactDOM.render(<CourseLandingContents />, document.getElementById('course_contents')); 


  // Sticky header
  function throttle(fn, delay) {
    var last = undefined;
    var timer = undefined;

    return function () {
      var now = +new Date();

      if (last && now < last + delay) {
        clearTimeout(timer);

        timer = setTimeout(function () {
          last = now;
          fn();
        }, delay);
      } else {
        last = now;
        fn();
      }
    };
  }

  function onScroll() {
    if (window.pageYOffset > 300) {
      $$header.classList.add('active');
    } else {
      $$header.classList.remove('active');
    }
  }

  var $$header = document.getElementById('cl-scrolling-cta');

  window.addEventListener('scroll', throttle(onScroll, 25));
})();
